export const DEFAULT_PAGE_SIZE = 50; // synced with DRF PAGE_SIZE
export const SEARCH_DEBOUNCE_TIME = 200;
export const DEFAULT_PAGE_SIZE_COMBOBOX = 100;
export const PREFETCH_STALE_TIME = 30_000;
